import { type FC, Fragment, useRef, useState, useMemo, useEffect } from 'react'
import { DateRangePicker } from 'react-date-range'
import moment from 'moment'
import {
	// StaticRanges,
	ThaiStaticRanges,
} from 'Configuration/ReactDateRange'
// import EnLocale from 'date-fns/locale/en-US'
import ThLocale from 'date-fns/locale/th'

interface Props {
	customBtnClass?: string
	customIcon?: JSX.Element
	startDate: string
	endDate: string
	onChangeState: (key: string, value: any) => void
}

const SmartCalendarButton: FC<Props> = ({
	customBtnClass,
	customIcon,
	startDate,
	endDate,
	onChangeState,
}) => {
	const filterDateRef = useRef<any>(null)
	const [openDate, setOpenDate] = useState(false)

	const dateRange = useMemo(() => {
		if (startDate && endDate) {
			return `${moment(startDate).format('MMM D, YYYY')} - ${moment(endDate).format('MMM D, YYYY')}`
		}

		return 'Select Date Range'
	}, [startDate, endDate])

	useEffect(() => {
		const handleClickOutside = (event: any) => {
			if (filterDateRef.current && !filterDateRef.current.contains(event.target)) {
				setOpenDate(false)
			}
		}

		document.addEventListener('mousedown', handleClickOutside)
		return () => {
			document.removeEventListener('mousedown', handleClickOutside)
		}
	}, [])

	return (
		<Fragment>
			<div className="d-flex flex-column flex-xl-row mb-5 mb-xl-0 position-relative">
				<button
					className={
						customBtnClass ??
						'btn btn-sm btn-kumopack-primary-700 text-kumopack-base-white w-100'
					}
					onClick={() => setOpenDate(prevState => !prevState)}>
					{customIcon ?? (
						<img
							src="/media/icons/kumopack/white-calendar.svg"
							alt="Kumopack Calendar Icon"
							width={20}
							height={20}
						/>
					)}{' '}
					{dateRange}
				</button>

				{openDate && (
					<div
						ref={filterDateRef}
						className="position-absolute top-50"
						style={{ zIndex: 999, left: '-315%' }}>
						<DateRangePicker
							showPreview={false}
							showDateDisplay={false}
							moveRangeOnFirstSelection={false}
							retainEndDateOnFirstSelection={false}
							months={2}
							direction="horizontal"
							rangeColors={['#0096d4']}
							className="border border-kumopack-grey-900 rounded overflow-hidden"
							ranges={[
								{
									startDate: moment(startDate).toDate(),
									endDate: moment(endDate).toDate(),
									key: 'selection',
								},
							]}
							onChange={result => {
								if (result?.selection) {
									onChangeState('startPeriod', result.selection.startDate)
									onChangeState('endPeriod', result.selection.endDate)
								}
							}}
							// locale={EnLocale}
							locale={ThLocale}
							maxDate={moment().toDate()}
							staticRanges={ThaiStaticRanges}
							inputRanges={[]}
						/>
					</div>
				)}
			</div>
		</Fragment>
	)
}

export default SmartCalendarButton
